module.exports = __webpack_public_path__ + "img/trash-solid.121c0ffe.svg";